import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-[#0A0A0C] border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src="/logo64.png" alt="MorphMX" className="w-8 h-8" />
              <span className="font-semibold text-xl text-zinc-100">MorphMX</span>
            </Link>
            <p className="text-sm text-zinc-500 mb-2">
              El marketplace premium de genética animal en México.
            </p>
            <p className="text-xs text-purple-400 italic mb-4">
              La Genética se encuentra aquí
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="p-2 rounded-full bg-white/5 text-zinc-400 hover:text-zinc-100 hover:bg-white/10 transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="p-2 rounded-full bg-white/5 text-zinc-400 hover:text-zinc-100 hover:bg-white/10 transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="p-2 rounded-full bg-white/5 text-zinc-400 hover:text-zinc-100 hover:bg-white/10 transition-colors">
                <Twitter className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Marketplace */}
          <div>
            <h4 className="text-sm font-semibold text-zinc-100 mb-4 tracking-wide uppercase">Marketplace</h4>
            <ul className="space-y-2">
              <li><Link to="/explorar" className="text-sm text-zinc-500 hover:text-zinc-300 transition-colors">Explorar</Link></li>
              <li><Link to="/categorias" className="text-sm text-zinc-500 hover:text-zinc-300 transition-colors">Categorías</Link></li>
              <li><Link to="/criadores" className="text-sm text-zinc-500 hover:text-zinc-300 transition-colors">Criadores</Link></li>
              <li><Link to="/precios" className="text-sm text-zinc-500 hover:text-zinc-300 transition-colors">Precios</Link></li>
            </ul>
          </div>

          {/* Vendedores */}
          <div>
            <h4 className="text-sm font-semibold text-zinc-100 mb-4 tracking-wide uppercase">Vendedores</h4>
            <ul className="space-y-2">
              <li><Link to="/registro?role=seller" className="text-sm text-zinc-500 hover:text-zinc-300 transition-colors">Vender</Link></li>
              <li><Link to="/precios" className="text-sm text-zinc-500 hover:text-zinc-300 transition-colors">Planes</Link></li>
              <li><Link to="/dashboard" className="text-sm text-zinc-500 hover:text-zinc-300 transition-colors">Dashboard</Link></li>
              <li><a href="#" className="text-sm text-zinc-500 hover:text-zinc-300 transition-colors">Centro de ayuda</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold text-zinc-100 mb-4 tracking-wide uppercase">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/terminos" className="text-sm text-zinc-500 hover:text-zinc-300 transition-colors">Términos y Condiciones</Link></li>
              <li><Link to="/privacidad" className="text-sm text-zinc-500 hover:text-zinc-300 transition-colors">Aviso de Privacidad</Link></li>
              <li><Link to="/politicas" className="text-sm text-zinc-500 hover:text-zinc-300 transition-colors">Políticas</Link></li>
              <li><a href="mailto:contacto@morphmx.com" className="text-sm text-zinc-500 hover:text-zinc-300 transition-colors">Contacto</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-zinc-600">
            © {new Date().getFullYear()} MorphMX. Todos los derechos reservados.
          </p>
          <p className="text-xs text-purple-400 italic">
            La Genética se encuentra aquí 🇲🇽
          </p>
        </div>
      </div>
    </footer>
  );
}
